<p-messages [value]="messages"></p-messages>
<form [formGroup]="addMessageForm" (ngSubmit) = "onSubmit()">
  <div class="ui-grid ui-grid-responsive formcontainer"> 
    <div>
      <div class="formgroup">
        <div class="ui-grid-row">
          <div class="ui-grid-col-12">
            <p-multiSelect 
              [options]="items"
              defaultLabel="To"
              [maxSelectedLabels]="1"
              formControlName="Person"
              [defaultLabel]="recipients ? 'To' : 'Loading..'"
              [virtualScroll]="true"
              [style]="{'width':'50%', 'margin-right':'5px;'}">
            </p-multiSelect>
            <i class="hoverLink" (mouseover)="op.show($event)" (mouseout)="op.hide($event)">Selected Items</i>
            <div *ngIf="person.invalid 
                  && person.touched
                  && person.errors.required" class="custom-required">
              Please select a Recipient.
          </div>
          </div>
        </div>   
      </div>
      
      <div class="formgroup" *ngIf="canSendMessagesToExternal">
        <div class="ui-grid-row">
          <div class="ui-grid-col-12">
            <input type="text" pInputText placeholder="External Email Addresses" formControlName="ExternalEmail">
            <div *ngIf="externalEmail.invalid 
                  && externalEmail.touched
                  && (externalEmail.errors.email || externalEmail.errors.invalidEmail)" class="custom-required">
                  Please enter a valid Email
            </div>
          </div>
        </div>
      </div>
      <div class="formgroup">
        <div class="ui-grid-row">
          <div class="ui-grid-col-12">
              <label for="loginEnabled">Attachment</label>
          </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-6">
              <p-fileUpload #fileInput name="attachments" 
                customUpload="true" 
                multiple="true" 
                [showUploadButton]="false" (uploadHandler)="uploadFile($event)"></p-fileUpload>
            </div>
        </div>
      </div>
      <div class="formgroup">
        <div class="ui-grid-row">
          <div class="ui-grid-col-12">
            <input type="text" pInputText placeholder="Subject" formControlName="Subject"/>
            <div *ngIf="subject.invalid 
                  && subject.touched
                  && subject.errors.required" class="custom-required">
              Please enter the Subject.
          </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="formgroup">
        <div class="ui-grid-row">
          <div class="ui-grid-col-12">
            <p-checkbox appendTo="body" binary="true" label="High Importance" formControlName="HighImportance" binary="true"></p-checkbox>
          </div>
        </div>           
      </div>
      <div class="formgroup">
        <div class="ui-grid-row">
          <div class="ui-grid-col-12">
            <textarea pInputTextarea placeholder="Message" formControlName="Body" [maxlength]="2500"></textarea>
            <div>{{2500 - body.value.length}} characters remaining</div>
            <div *ngIf="body.invalid 
                  && body.touched
                  && body.errors.required" class="custom-required">
              Please enter the Message.
          </div>
          </div>
        </div>
      </div>
      <div class="formgroup">
        <div class="ui-grid-row">
          <div class="ui-grid-col-12 footer">
            <button pButton type="submit" label="{{processing ? 'Processing' : 'Send'}}" [disabled]="formValid()"></button>
            <button pButton type="button" (click)="cancelMessage()" label="Cancel" class="ui-button-secondary"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<p-overlayPanel #op [dismissable]="true">
  <div *ngIf=" recipientGroup && recipientGroup.AvailableGroup">
    <div *ngFor="let item of recipientGroup.AvailableGroup">
        <ul>
          <li>
            <b>{{item}}</b>
            <ul>
              <li *ngFor="let groupItem of personByGroupKey(item)">{{groupItem}}</li>
            </ul>
          </li>
        </ul>
      </div>
  </div>
</p-overlayPanel>
<p-confirmDialog header="Confirmation" [rejectVisible]="false" acceptLabel="Ok" icon="pi pi-exclamation-triangle"></p-confirmDialog>